import { Axios, AxiosResponse } from 'axios';
import { getRequest, putRequest } from '../../Services/HttpService';
import { TABLE_FUEL_CARD } from '../../Services/TableService';
import { VehicleApiResponse, VehicleApiResponseData, VehicleValidationApiResponse } from './types';
import { IOption } from '../Forms/CmdField';

const RESPONSE_OK = 'ok';

export const getFuelCardFormData = async () => {
  const response: Record<string, any> | false = await getRequest(`/v1/${TABLE_FUEL_CARD}/form`, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.data.form && response.status === 200) {
    return response.data.form.inputs;
  }
  return false;
};

export const getEditingData = async (
  id: number | string
): Promise<VehicleApiResponseData | false> => {
  const response: VehicleApiResponse | AxiosResponse | false = await getRequest<
    VehicleApiResponse | false
  >(`/v1/vehicle/${id}`);
  if (response) {
    return (response as VehicleApiResponse).vehicle as VehicleApiResponseData;
  }
  return false;
};

export const getValidation = async (): Promise<VehicleValidationApiResponse | false> => {
  const response: VehicleValidationApiResponse | AxiosResponse | false =
    await getRequest(`/v1/vehicle/validation`);
  if (response) {
    return response as VehicleValidationApiResponse;
  }
  return false;
};

export const getFuelCardsOptions = async (customerId: string | null, vehicleId: number | null) => {
  const response: IOption[] | AxiosResponse | false = await getRequest<IOption[]>(
    `/v1/vehicle/form/fuelCards${customerId ? `?customerId=${customerId}` : ''}${
      vehicleId ? `&vehicleId=${vehicleId}` : ''
    }`
  );
  if (response) {
    return response as IOption[];
  }
  return false;
};

export const getFuelCardsValues = async (vehicleId: number | null) => {
  const response = await getRequest<Record<string, any>>(
    `/v1/vehicle/form/fuelCardsAssigned${vehicleId ? `?vehicleId=${vehicleId}` : ''}`,
    { returnAxiosResponse: true }
  );
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return false;
};

export const getVehicleTypeIdOptions = async (): Promise<IOption[] | false> => {
  const response = await getRequest<IOption[] | AxiosResponse | false>(
    `/v1/vehicle/form/vehicleTypeList`
  );
  if (response) {
    return response as IOption[];
  }
  return false;
};

export const getDefaultDriverIdOptions = async (
  customerId: number | null
): Promise<IOption[] | false> => {
  const url = `/v1/vehicle/form/defaultDriverList${customerId ? `?customerId=${customerId}` : ''}`;
  const response: IOption[] | AxiosResponse | false = await getRequest(url);
  if (response) {
    return response as IOption[];
  }
  return false;
};

export const getCostCenterIdOptions = async (
  vehicleId: string | number
): Promise<IOption[] | false> => {
  const url = `/v1/vehicle/form/costCenterList?vehicleId=${vehicleId}`;
  const response: IOption[] | AxiosResponse | false = await getRequest(url);
  if (response) {
    return response as IOption[];
  }
  return false;
};

export const getFuelTypeListOptions = async () => {
  const response: IOption[] | AxiosResponse | false = await getRequest(
    `/v1/vehicle/form/fuelTypeList`
  );
  if (response) {
    return response as IOption[];
  }
  return false;
};

export const editVehicle = async (values, id: number | null) => {
  if (!id) {
    return false;
  }
  const response: Record<string, any> | false = await putRequest(`/v1/vehicle/${id}/edit`, values);
  return !!(response && response.status === RESPONSE_OK);
};
